import { getJwtToken } from "@features/auth";
import { ENV } from "@utils/env";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

export const useEtiquetteEditionPageVM = () => {
    const jwt = useSelector(getJwtToken);

    const yearsList = Array.from({ length: 30 }, (_, index) => moment().year() - index);
    const defaultYears = [moment().year(), moment().year() - 1, moment().year() - 2, moment().year() - 3];

    const openPrintEtiquettes = useCallback(({ years }: { years: number[] }) => {
        window.open(`${ENV.API_URL}/member/members/edition/etiquettes?jwt=${jwt}&years=${years.join(',')}`, '_blank');
    }, [jwt]);

    return {
        openPrintEtiquettes,
        yearsList,
        defaultYears,
    };
};
